import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import ProfileHeader from "../components/profile/profileHeader";
import ProfileInfo from "../components/profile/ProfileInfo";
import ProfileForm from "../components/profile/ProfileForm";
import ProfilePassword from "../components/profile/ProfilePassword";
import { useToast } from "../context/ToastContext";

import "../components/profile/profile.css";

export default function Profile() {
  const { user, loading } = useAuth();
  const [edit, setEdit] = useState(false);
  const [tab, setTab] = useState("info");
  const { showToast } = useToast(); 


  if (loading || !user) return null;

  return (
    <div className="profilePage">
      <ProfileHeader user={user} />

      {/* Tabs */}
      <div className="profileTabs">
        <button
          className={tab === "info" ? "active" : ""}
          onClick={() => {
            setEdit(false);
            setTab("info");
          }}
        >
          Informations
        </button>
        <button
          className={tab === "security" ? "active" : ""}
          onClick={() => setTab("security")}
        >
          Sécurité
        </button>
      </div>

       
      {tab === "info" && (
        !edit ? (
          <ProfileInfo user={user} onEdit={() => setEdit(true)} />
        ) : (
          <ProfileForm
            user={user}
            
            onCancel={() => setEdit(false)}
            onSave={() => {
              setEdit(false);
            
            }}
          />
        )
      )}

      {tab === "security" && (
        <ProfilePassword
          onSuccess={() => showToast("Mot de passe mis à jour", "success")}
        />
      )}

     
    </div>
  );
}
